/**
 * Custom Accordion Implementation
 * 
 * Simple, reliable accordion that works without Bootstrap's problematic CSS
 */

document.addEventListener('DOMContentLoaded', function () {

  function initializeAccordions() {
    const accordionButtons = document.querySelectorAll('[data-bs-toggle="collapse"]');

    const targetIdMap = new Map();

    accordionButtons.forEach((button, index) => {
      const originalTarget = button.getAttribute('data-bs-target') || button.getAttribute('href');

      if (targetIdMap.has(originalTarget)) {
        // This target ID is already used, create a unique one
        const groupId = Date.now() + Math.random().toString(36).substr(2, 9);
        const newTargetId = `${originalTarget}-accordion-group-${groupId}`;

        // Update button to point to new target
        if (button.getAttribute('data-bs-target')) {
          button.setAttribute('data-bs-target', newTargetId);
        } else {
          button.setAttribute('href', newTargetId);
        }

        // Clone the original target element and update its ID
        const originalElement = document.querySelector(originalTarget);
        if (originalElement) {
          const clonedElement = originalElement.cloneNode(true);
          clonedElement.id = newTargetId.substring(1); // Remove the # prefix
          originalElement.parentNode.insertBefore(clonedElement, originalElement.nextSibling);
        }
      } else {
        targetIdMap.set(originalTarget, button);
      }
    });

  }

  // Initialize accordions
  initializeAccordions();

  // Add click handlers for custom functionality
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-bs-toggle="collapse"]') || e.target.closest('[data-bs-toggle="collapse"]')) {
      const button = e.target.matches('[data-bs-toggle="collapse"]') ? e.target : e.target.closest('[data-bs-toggle="collapse"]');
      const targetId = button.getAttribute('data-bs-target') || button.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const isExpanded = !targetElement.classList.contains('show');
        const buttonText = button.textContent.trim();

        // Screen reader announcements
        setTimeout(() => {
          const announcement = `${buttonText} ${isExpanded ? 'expanded' : 'collapsed'}`;
          const srAnnouncement = document.createElement('div');
          srAnnouncement.setAttribute('aria-live', 'polite');
          srAnnouncement.setAttribute('aria-atomic', 'true');
          srAnnouncement.className = 'sr-only';
          srAnnouncement.textContent = announcement;
          document.body.appendChild(srAnnouncement);

          setTimeout(() => {
            document.body.removeChild(srAnnouncement);
          }, 1000);
        }, 100);
      }
    }
  });
});